import React,{useState,useEffect} from "react";
import { isMobileTablet } from "../utils";
import MobileRoutes from "../mobile/routes";
import { Provider } from 'react-redux';
import DesktopRoutes from "../desktop/routes";
import { PersistGate } from 'redux-persist/integration/react';
import { MessageProvider } from "../utils/context";
import { store, persistor } from '../store';

const App =() => {
  const [isMobileView, setIsMobileView] = useState(isMobileTablet());
  const checkIsMobileView = () => {
    setIsMobileView(isMobileTablet());
  };
  useEffect(() => {
    // 初始化检测
    checkIsMobileView();

    // 添加防抖的resize监听
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkIsMobileView, 100);
    };

    window.addEventListener("resize", handleResize);
    
    // 清除监听器
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MessageProvider>
          {isMobileView ? <MobileRoutes />: <DesktopRoutes />}
        </MessageProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
